import { useEffect, useState } from "react"

import { Label } from "semantic-ui-react"

import { Partner } from "../../models"

import { PartnerService } from "../../services"

import { PartnerList, LoadingSpinner, ErrorMessage } from "../../components"

import { FeedbackMessage } from "../../constants"

export function AdminsysPartnersPage() {

    const [partners, setPartners] = useState<Partner[]>([])
    const [loadingPartners, setLoadingPartners] = useState(true)
    const [errorFetchingPartners, setErrorFetchingPartners] = useState(false)

    useEffect(() => {
        PartnerService.getPartners('sys')
            .then(data => setPartners(data))
            .catch(_ => setErrorFetchingPartners(true))
            .finally(() => setLoadingPartners(false))
    }, [])

    return <div>
        { loadingPartners && <LoadingSpinner />}
        { errorFetchingPartners && <ErrorMessage errorText={FeedbackMessage.PARTNER_FETCH_ERROR} />}
        { !loadingPartners && !errorFetchingPartners &&
            <div style={{width: '80%', margin: 'auto'}}>
                <div className='headerRow'>
                    <div className='flex-center'>
                        <h3 className='mb-0 mr-25'><Label color='orange'>{partners.length}</Label> &nbsp; Partenaires</h3>
                    </div>
                </div>
                <PartnerList partners={partners} userRole='Admin' />
            </div>
        }
    </div>

}
